import React, { useContext } from "react";

import { SessionContext } from "@/stores/SessionContext";

interface AuthenticatedContentProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

/**
 * Renders its children only if the user is authenticated. Optionally renders fallback content if the user is not
 * authenticated. If no fallback is provided, renders nothing when not authenticated.
 */
export const AuthenticatedContent: React.FC<AuthenticatedContentProps> = ({ children, fallback = null }) => {
  const { session } = useContext(SessionContext);
  return session ? <>{children}</> : fallback;
};
